class Contact {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    // 講習時間目安 パラメータ引き渡し
    const searchParams = new URLSearchParams( window.location.search );

    $("[name='講習時間目安']").attr('value', searchParams.get('send'));

    // ラジオボタン　選択によるコンテンツ切り替え
    const radioBtns = document.querySelectorAll(".js-contact-radio")
    const selectedContent = document.querySelectorAll(".js-contact-content ")

    let  hiddenValue = document.getElementsByName("sendmail")[0]


    const mail01 = document.querySelector(".js-mail-01")
    const mail02 = document.querySelector(".js-mail-02")


    radioBtns.forEach((btn, i) => {

      if(btn.checked){

        if(btn.value === "講習のご予約"){
          selectedContent[0].classList.add("is-active")
          selectedContent[1].classList.remove("is-active")
        }else if(btn.value === "ご質問"){
          selectedContent[0].classList.remove("is-active")
          selectedContent[1].classList.add("is-active")
        }else{
          console.log("該当のものはありません");
        }
      }

      btn.addEventListener("click", () => {

        selectedContent.forEach(content => {

          //表示リセット
          content.classList.remove("is-active")
        })

        selectedContent[i].classList.add("is-active")

      })

    })

    // 入力画面

    const inputPage  = document.querySelector(".mw_wp_form_input")

    if(inputPage){
      mail01.addEventListener("change", (e) => {
        hiddenValue.setAttribute("value",e.target.value)
      })
      mail02.addEventListener("change", (e) => {
        hiddenValue.setAttribute("value",e.target.value)
      })
    }



    // 確認画面の表示出し分け
    const confirmRadio = document.querySelector(".mw_wp_form_confirm .radio_btn")
    if(confirmRadio){
      const confirmRadioText = confirmRadio.textContent.trim()

      selectedContent.forEach(content => {
        content.classList.remove("is-active")
      })
      if(confirmRadioText === "講習のご予約"){
        selectedContent[0].classList.add("is-active")
        selectedContent[1].innerHTML = ""
        console.log("講習のご案内");
      }else if(confirmRadioText === "ご質問"){
        selectedContent[0].innerHTML = ""
        selectedContent[1].classList.add("is-active")
        console.log("ご質問");
      }else{
        console.log("該当のものはありません");
      }
    }


    //チェクボックス単一選択
    $.each($('.check_btn'), function(index, value) {
      $(`.check_btn-0${index + 1} .check_btn_item`).on('click', function() {
        if ($(this).prop('checked')){
          // 一旦全てをクリアして再チェックする
          $(`.check_btn-0${index + 1} .check_btn_item`).prop('checked', false);
          $(this).prop('checked', true);
        }
      });
    })
  }
}